import { DoraGradeThresholds } from "../getDoraGrade";

export const CHART_TYPE_STORAGE_KEY = "lead-time-for-changes";

// Quartile thresholds in seconds (upper bound of each tier)
export const LEAD_TIME_THRESHOLDS: DoraGradeThresholds = {
  excellentMax: 27_440,
  fairMax: 93_923,
};
